import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

// Actions
import { openModal as openModalAction, closeModal } from '../../actions/modalActions';

import { Panel } from '../Panel';
import { MapTCC } from '../Map';
import Selectors from '../Selectors/Selectors';
import { Legend } from '../Legend';
import { Modal } from '../Modal';
import SplitViewButton from '../../components/View/SplitViewButton';
import CloseSplitViewButton from '../../components/View/CloseSplitViewButton';
import { splitViewEnabledSelector } from '../../selectors/splitViewSelectors';
import { trackEvent } from '../../actions/analyticsActions';
import { closeSplitView, switchView } from '../../utils/url';
import styles from './View.css';
import { FieldFeature } from '../../types';

// TODO - Remove SonarQube disablement after BTR-931 is done.
export class View extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showMap: props.appInitializerHasFetched,
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { showMap } = this.state;
    const { appInitializerHasFetched } = this.props;

    if (
      !showMap &&
      !appInitializerHasFetched &&
      nextProps.appInitializerHasFetched
    ) {
      this.setState({ showMap: true });
    }
    if (
      showMap &&
      appInitializerHasFetched &&
      !nextProps.appInitializerHasFetched
    ) {
      this.setState({ showMap: false });
    }
  }

  splitView = () => {
    const {
      activeSeasons,
      activeMapLayers,
      season,
      layer,
      fieldId,
      trackAnalyticsEvent,
    } = this.props;

    const seasonIds = activeSeasons.map((activeSeason) => activeSeason.id);
    const layerIds = activeMapLayers.map((activeLayer) => activeLayer.id);

    // Create another view with the same season and layer.
    switchView(1, season, seasonIds, layer, layerIds, fieldId);

    if (trackAnalyticsEvent) {
      trackAnalyticsEvent('split_view', 'selected');
    }

  };

  closeSplitView = () => {
    const { season, layer, fieldId, trackAnalyticsEvent } = this.props;

    closeSplitView(season, layer, fieldId);

    if (trackAnalyticsEvent) {
      trackAnalyticsEvent('split_view', 'closed');
    }
  };

  render() {
    // NOSONAR
    const {
      appInitializerHasFetched,
      index,
      panel,
      mapLayer,
      legend,
      userHasFetched,
      content,
      modal,
      isSplitViewButtonVisible,
      isSplitViewEnabled,
    } = this.props;
    const hasFetched = appInitializerHasFetched && userHasFetched;
    const _legend =
      legend &&
      React.cloneElement(legend, {
        index,
        testId: 'dmb-legend',
      });
    const _panel = hasFetched && panel ? panel : undefined;
    const _mapLayer =
      hasFetched && mapLayer
        ? React.cloneElement(mapLayer, { index })
        : undefined;

    const _modal = modal ? React.cloneElement(modal) : undefined;
    const { showMap } = this.state;

    return (
      <div className={styles.view} data-test-id="dmb-view">
        <Panel index={index} panel={_panel} />
        <Modal index={index} modal={_modal} />
        {content || (
          <MapTCC index={index} mapLayer={_mapLayer} showMap={showMap} />
        )}
        {hasFetched && !content && <Selectors index={index} />}
        {hasFetched && legend && !content && <Legend legendItem={_legend} />}
        {hasFetched && !content && (
          <SplitViewButton
            onClick={this.splitView}
            show={isSplitViewButtonVisible}
          />
        )}
        {!content && (
          <CloseSplitViewButton
            onClick={this.closeSplitView}
            show={isSplitViewEnabled && index === 0}
          />
        )}
      </div>
    );
  }
}

View.propTypes = {
  activeMapLayers: PropTypes.array,
  activeSeasons: PropTypes.array,
  appInitializerHasFetched: PropTypes.bool,
  content: PropTypes.object,
  fieldId: PropTypes.string,
  index: PropTypes.number,
  isSplitViewButtonVisible: PropTypes.bool,
  isSplitViewEnabled: PropTypes.bool,
  layer: PropTypes.string,
  legend: PropTypes.object,
  mapLayer: PropTypes.object,
  modal: PropTypes.object,
  panel: PropTypes.object,
  season: PropTypes.string,
  trackAnalyticsEvent: PropTypes.func,
  userHasFetched: PropTypes.bool,
  isProductPackagingSplitViewFFEnabled: PropTypes.bool,
  openModal: PropTypes.func.isRequired,
  closeModal: PropTypes.func.isRequired
};

function mapStateToProps(state, props) {
  return {
    activeMapLayers: state.layers.activeMapLayers,
    activeSeasons: state.seasons.activeSeasons,
    appInitializerHasFetched: state.appInitializer.hasFetched,
    fieldId: state.field.id,
    isSplitViewEnabled: state.layers.isSplitViewEnabled,
    isSplitViewButtonVisible: splitViewEnabledSelector(state),
    layer: state.layers.activeMapLayers[props.index].id,
    season: state.seasons.activeSeasons[props.index].id,
    userHasFetched: state.user.hasFetched,
    hasSplitViewAsset: state.field.features.includes(FieldFeature.SPLIT_VIEW),
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      trackAnalyticsEvent: trackEvent,
      openModal: openModalAction,
      closeModal,
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(View);
